import { put } from 'core/middlewares/utilities';
import { checkout } from 'core/use-cases';
import { history } from 'core/use-cases/utilities';

import { getters } from './getters';
import { getLocationPathname } from 'core/utilities';

/**
 * Discount and gifts process
 *
 */
export function* processFetch() {
  const { canSubmit }: getters.Cart = yield getters.getCart();
  const pathname = getLocationPathname();

  if (pathname === '/checkout' || pathname === '/checkout/brindes') {
    if (canSubmit) {
      yield put(checkout.actions.processFetch.request());

      return;
    }

    const homePage: getters.RoutePath = yield getters.getHomepageRoute();

    history.push(homePage);
  }
}
